
jQuery(function($) {
	
	$(".primary-navigation > ul > li.menu-item-has-children ").hoverIntent({
	    over: 
		    function() {
				// console.log(el);
				$(this).addClass('hover');
			},
		timeout: 200,
	    out: 
		    function() {
				// console.log(el);
				$(this).removeClass('hover');
			},
	});

	// reference page
	$('.init-wrapper').on('click', function(e) {
		e.preventDefault();
		location.href = $(this).data('href');
	});

});